import React from "react";
import Layout from "../layout/layout";
import Slider from "react-slick";
import slider1 from "../../assets/images/home/slide.png";
import slider2 from "../../assets/images/home/slide1.png";
import rubyrollicon from "../../assets/images/home/rubyroll-icon.svg";
import casinoicon from "../../assets/images/home/casino-icon.svg";
import roulette from "../../assets/images/home/roulette.svg";
import dice from "../../assets/images/home/dice.svg";
import mines from "../../assets/images/home/mines.svg";
import tower from "../../assets/images/home/tower.svg";
import livegame from "../../assets/images/home/live-games.svg";
import slot from "../../assets/images/home/slot.svg";
import { Table } from "react-bootstrap";
import coin from "../../assets/images/header/gem.png";
import { Tabs, Tab } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./home.css";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <Layout>
      <div className="home-page">
        <HomeSlider />
        <RubyRollOriginals />
        <Casino />
        <AllHistory />
      </div>
    </Layout>
  );
};

export default Home;

const HomeSlider = () => {
  const settings = {
    centerMode: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: '250px',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          centerMode: true,
          centerPadding: '150px',
        }
      },
      {
        breakpoint:768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '100px',
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '50px',
        }
      }
    ]
  };

  return (
    <div className="home-slider">
      <div className="container">
        <div className="home-slider-content">
          <Slider {...settings}>
            <div className="home-slider-box">
              <div className="home-slider-space">
                <img src={slider1} alt="" />
              </div>
            </div>
            <div className="home-slider-box">
            <div className="home-slider-space">
                <img src={slider2} alt="" />
              </div>
            </div>
            <div className="home-slider-box">
            <div className="home-slider-space">
                <img src={slider1} alt="" />
              </div>
            </div>
            <div className="home-slider-box">
            <div className="home-slider-space">
                <img src={slider2} alt="" />
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
};

const RubyRollOriginals = () => {
  return (
    <div className="home-rubyroll">
      <div className="container">
        <h2>
          <img src={rubyrollicon} alt="" /> RubyRoll Originals
        </h2>
        <div className="home-rubyroll-grid">
          <div className="home-rubyroll-box">
            <Link to="/roulette">
            <div className="home-rubyroll-cover">
              <img src={roulette} alt="" />
            </div>
            <h4>Roulette</h4>
            </Link>
          </div>
          <div className="home-rubyroll-box">
            <Link to="/dice">
            <div className="home-rubyroll-cover">
              <img src={dice} alt="" />
            </div>
            <h4>Dice</h4>
            </Link>
          </div>
          <div className="home-rubyroll-box">
          <Link to="/mines">
            <div className="home-rubyroll-cover">
              <img src={mines} alt="" />
            </div>
            <h4>Mines</h4>
            </Link>
          </div>
          <div className="home-rubyroll-box">
          <Link to="/tower">
            <div className="home-rubyroll-cover">
              <img src={tower} alt="" />
            </div>
            <h4>Tower</h4>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

const Casino = () => {
  return (
    <div className="home-casino">
      <div className="container">
        <h2>
          <img src={casinoicon} alt="" /> Casino
        </h2>
        <div className="home-casino-grid">
          <div className="home-casino-box">
          <Link to="/livegames">
            <div className="home-casino-cover">
              <img src={livegame} alt="" />
            </div>
            <h4>Live Games</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
            </Link>
          </div>
          <div className="home-casino-box">
          <Link to="/slots">
            <div className="home-casino-cover">
              <img src={slot} alt="" />
            </div>
            <h4>Slots</h4>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

const AllHistory = () => {
  return (
    <div className="container">
      <div className="dice-tab-grid">
        <div className="dice-tab">
          <Tabs defaultActiveKey="allbet" id="uncontrolled-tab-example">
            <Tab eventKey="allbet" title="All Bets">
              <HistoryTable />
            </Tab>
            <Tab eventKey="lucky" title="Lucky Wins">
              <HistoryTable />
            </Tab>
            <Tab eventKey="mybet" title="My Bets">
              <HistoryTable />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

const HistoryTable = () => {
  return (
    <div className="dice-history">
      <Table striped bordered variant="dark" responsive>
        <thead>
          <tr>
            <th>Game</th>
            <th>User</th>
            <th>Time</th>
            <th>Wagered </th>
            <th>Multiplier</th>
            <th>Profit</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Monopoly</td>
            <td>Dayhzz</td>
            <td>4:09 PM</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
            <td>2.00x</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
          </tr>
          <tr>
            <td>Crazy Time</td>
            <td>Dayhzz</td>
            <td>4:09 PM</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
            <td>2.00x</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
          </tr>
          <tr>
            <td>Tower</td>
            <td>Dayhzz</td>
            <td>4:09 PM</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
            <td>2.00x</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
          </tr>
          <tr>
            <td>Mines</td>
            <td>Dayhzz</td>
            <td>4:09 PM</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
            <td>2.00x</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
          </tr>
          <tr>
            <td>Dice</td>
            <td>Dayhzz</td>
            <td>4:09 PM</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
            <td>2.00x</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
          </tr>
          <tr>
            <td>Roulette</td>
            <td>Dayhzz</td>
            <td>4:09 PM</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
            <td>2.00x</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
          </tr>
          <tr>
            <td>Dice</td>
            <td>Dayhzz</td>
            <td>4:09 PM</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
            <td>2.00x</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
          </tr>
          <tr>
            <td>Tower</td>
            <td>Dayhzz</td>
            <td>4:09 PM</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
            <td>2.00x</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
          </tr>
          <tr>
            <td>Dice</td>
            <td>Dayhzz</td>
            <td>4:09 PM</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
            <td>2.00x</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
          </tr>
          <tr>
            <td>Tower</td>
            <td>Dayhzz</td>
            <td>4:09 PM</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
            <td>2.00x</td>
            <td>
              <div className="transaction-value">
                <img src={coin} alt="" /> $259.25
              </div>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};
